import React from "react";

// Form-field wrapper: small uppercase label above a control, optional helper below.
// Theme-aware via CSS vars, so the Quantiv retheme reaches every form through this
// one file instead of five hand-rolled copies.
//
// Consolidated from five byte-identical-modulo-props local definitions:
//   Pages/Leaves/ApplyLeaveModal.jsx  (was the de-facto shared one, re-exported there
//                                      for the four pages that already import it)
//   Pages/Leaves/LeavesPage.jsx       {label, children}
//   Pages/Settings/SettingsPage.jsx   {label, helper, children}
//   Pages/Attendance/AttendancePage.jsx  {label, children, full}
//   Pages/HR/HRAdmin.jsx                 {label, children, full}
// The prop set below is their union, so each old call site renders identically:
// `full` omitted leaves the wrapper unstyled, `helper` omitted renders nothing.
//
// Deliberately NOT consolidated — same name, different components:
//   Pages/Tasks/TaskCreateModalV2.jsx  horizontal 120px grid, "label:" with a colon
//   Pages/Profile/ProfileView.jsx      real <label> element, Tailwind ink tokens
//   Pages/Analytics/TaskTimeline.jsx   takes `value`, renders a read-only stat
// Folding those in here would change how they look, which this refactor must not do.

export default function Field({ label, helper, full, children }) {
  return (
    <div style={full ? { gridColumn: "1 / -1" } : undefined}>
      <div style={{ fontSize: 10, color: "var(--text-tertiary)", textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 600, marginBottom: 4 }}>{label}</div>
      {children}
      {helper && <div style={{ fontSize: 11, color: "var(--text-tertiary)", marginTop: 4 }}>{helper}</div>}
    </div>
  );
}
